








































































import { Component, Prop } from 'vue-property-decorator';
import TemplateMixin from '../TemplateMixin.vue';
import SearchAboutDropdown from './sysComponents/search-about-dropdown.vue';

import * as api from '@/api';
/**
 * Ticket详情
 *
 * @author liyuyao
 * @date 03/25/2019
 */
@Component({
    components: {
        SearchAboutDropdown
    }
})
export default class ComponentAssociate extends TemplateMixin {
    @Prop({
        default: () => {
            return {};
        }
    })
    info: any;
    ticketId: number = 0;
    coeLink: string = '';
    originCoeLink: string = '';
    connectTTList: any = [];
    searchResult: any = [];
    coeVisible: Boolean = false;

    mounted() {
        this.ticketId = parseInt(this.$route.query.id as string, 10);
        this.getConnectPage();
    }
    async searchTicketByName(query) {
        if (query.trim().length < 1) {
            this.searchResult = [];
            return;
        }
        try {
            const res = await api.ticketApi.searchTicketByName(query);
            this.searchResult = res.data.items;
        } catch (e) {
            this.searchResult = [];
            console.log(e);
        }
    }
    ttLinkAdd(val) {
        if (val) {
            this.contentSave('TT', val);
        }
    }
    goToCOE() {
        if (this.coeLink) {
            window.open(this.coeLink, '_blank');
        }
    }
    async deleteLink(type, destination?) {
        if (type === 'COE' && !this.coeLink) {
            return;
        }
        const params: { source: number; linkType: string; destination?: number } = {
            source: this.ticketId,
            linkType: type
        };
        if (type === 'TT') {
            params.destination = destination;
        }
        const res = await api.ticketApi.deleteConnectPage(params);
        if (res.code === 200) {
            this.$mtd.message.success(`删除关联${type}成功`);
            if (type === 'COE') {
                this.coeLink = '';
                this.originCoeLink = '';
            } else {
                this.getConnectPage();
            }
        }
    }
    async contentSave(type, url) {
        interface Params {
            linkType: string;
            source: number;
            content?: string;
            destination?: number;
        }
        const params: Params = {
            linkType: type,
            source: this.ticketId
        };
        if (type === 'COE') {
            if (this.originCoeLink === this.coeLink) {
                return;
            }
            if (url.length > 2000) {
                this.coeLink = this.originCoeLink;
                this.$mtd.message.error('输入内容超过2000字符');
                return;
            }
            if (!this.judgeCoeLink(url)) {
                this.coeLink = this.originCoeLink;
                this.$mtd.message.error('请输入正确的COE链接');
                return;
            }
            params.content = url;
            const res = await api.ticketApi.connectCoe(params);
            if (res.code === 200) {
                this.originCoeLink = this.coeLink;
                this.$mtd.message.success('关联COE成功');
            }
        } else {
            params.destination = url;
            // params = [params];
            // try {
            //     const res = await api.ticketApi.connectTT(params);
            //     if (res.code === 200) {
            //         this.$mtd.message.success(`关联TT成功`);
            //         this.getConnectPage();
            //     }
            // } catch (e) {
            //     console.log(e);
            // }
        }
    }
    cancelSave() {
        this.coeLink = this.originCoeLink;
        this.coeVisible = false;
    }
    // 判断是否是coe链接
    judgeCoeLink(url) {
        const reg = /^(https:\/\/coe.mws.sankuai.com)/;
        return reg.test(url);
    }
    // getConnectPage
    async getConnectPage() {
        // const res = await api.ticketApi.getConnectPage(this.ticketId);
        // let { data, code } = res;
        // if (code === 200) {
        //     this.connectTTList = [];
        //     data.items.forEach((item) => {
        //         if (item.linkType === 'COE') {
        //             this.originCoeLink = item.content;
        //             this.coeLink = this.originCoeLink;
        //         }
        //         if (item.linkType === 'TT') {
        //             // 美维工单 单独处理
        //             if (item.destination === 110) {
        //                 let mwId = item.content.split('-')[1];
        //                 let destination = `https://helpdesk.sankuai.com/issue/view?id=${mwId}`;
        //                 this.connectTTList.push({
        //                     isMw: true,
        //                     destination: destination,
        //                     content: item.content
        //                 });
        //             } else {
        //                 this.connectTTList.push({
        //                     destination: item.destination,
        //                     content: item.content
        //                 });
        //             }
        //         }
        //         if (item.linkType === 'ONES') {
        //             this.$emit('withOnes', item.content, item.destination);
        //         }
        //         if (item.linkType === 'ITSM') {
        //             this.$emit('withItsm', item.content);
        //         }
        //     });
        // }
    }
    ticketsChange(val) {
        this.ttLinkAdd(val);
    }
    openCoeDropdown() {
        this.coeVisible = true;
    }
}
